export default __webpack_public_path__ + "static/media/KickAve.24025bf0.gif";